import { FormControl, TextField } from '@mui/material';

type NoteSectionProps = {
  label: string;
  value: string;
  onChange: (v: string) => void;
  required?: boolean;
  placeholder: string;
  id: string;
  existingNotes?: React.ReactNode | null;
};

const NoteSection: React.FC<NoteSectionProps> = ({
  label,
  value,
  onChange,
  required,
  placeholder,
  id,
}) => (
  <div className="pb-[10px] ml-[20px] flex flex-col">
    <label htmlFor={id} className="font-bold text-xl">
      {label}
    </label>
    <FormControl style={{ width: '80%' }}>
      <TextField
        data-testid={`note-section-${id}`}
        id={id}
        value={value}
        required={required}
        multiline
        rows={4}
        margin="dense"
        type="text"
        placeholder={placeholder}
        fullWidth
        variant="outlined"
        onChange={(e) => onChange(e.target.value)}
        slotProps={{
          htmlInput: { maxLength: 3000, sx: { fontSize: '1.40rem' } }
        }}
      />
    </FormControl>
  </div>
);

export default NoteSection;
